<script lang="ts">
	import CheckMarkCircleIcon from '../Icon/CheckMarkCircleIcon.svelte';
	import CheckMarkIcon from '../Icon/checkMarkIcon.svelte';
	import { classes } from '$lib/utils';

	export let title: string | null = null;
	// To supply class properties for the title string.
	export let titleClasses: string = '';
	export let highlights: Array<string>;
	export let icon: string;
	// To supply class properties for the highlight icon.
	export let iconClasses: string = 'w-4 h-4 min-w-[16px] mt-1.5';
	export let additionalClass: string = '';

	const iconComponents: Record<string, typeof CheckMarkIcon> = {
		CheckMarkIcon,
		CheckMarkCircleIcon
	};
</script>

<div class={classes(additionalClass, 'flex flex-col gap-4')}>
	{#if title}
		<div class={classes(titleClasses, 'text-xl')}>{title}</div>
	{/if}
	<div class="flex flex-col gap-2 w-fit">
		{#each highlights as highlight}
			<div class="flex flex-row gap-2">
				<div class={classes(iconClasses, 'text-purple min-w-[1.25rem] min-h-[1.25rem]')}>
					<svelte:component this={iconComponents[icon]} />
				</div>
				<div class="text-lg">{highlight}</div>
			</div>
		{/each}
	</div>
</div>
